import m from 'mithril'
import BaseView from './BaseView'

export default class FanorakelView extends BaseView {
  view(ctrl) {
    let { src, fanorakelId } = ctrl.vm
    let iframeName = `Fanorakel-${fanorakelId}`
    return m(`iframe[name=${iframeName}][frameborder=0][scrolling=no][src=${src}]`)
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/FanorakelView.js